import React, { useState, useRef, useEffect } from "react";
import axios from "../helper/axios";

const BillingStep = ({ onSubmit }) => {
  const [userDetails, setUserDetails] = useState([]);

  const [billingData, setBillingData] = useState({
    billing_user_name: "",
    billingAddress1: "",
    billingAddress2: "",
    billingCity: "",
    billingCountry: "",
    billingPin_code: "",
    billingState: "",
    billing_mobile: "",
  });

  const [checked, setChecked] = useState(true);

  const [shippingData, setShippingData] = useState({
    shipping_user_name: "",
    shippingAddress1: "",
    shippingAddress2: "",
    shippingCity: "",
    shippingCountry: "",
    shippingPin_code: "",
    shippingState: "",
    shipping_mobile: "",
  });

  const ref = useRef(null);

  const contact_details = localStorage.getItem("contactdetails");
  const loggedInUser = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const defaultEmail = localStorage.getItem("emailId");
  const user_type = localStorage.getItem("user_type");
  const user_name = localStorage.getItem("user_name");

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(
        `/maitri_search_users?user_id=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      );

      const userDetailsData = response.data.data;
      setUserDetails(userDetailsData);

      // Set default values based on userDetailsData if the fields are empty
      if (!billingData.firstName) {
        setBillingData({
          ...billingData,
          billing_user_name: userDetailsData[0].billing_user_name || "",
          billingAddress1: userDetailsData[0].billingAddress1 || "",
          billingAddress2: userDetailsData[0].billingAddress2 || "",
          billingCity: userDetailsData[0].billingCity || "",
          billingCountry: userDetailsData[0].billingCountry || "",
          billingPin_code: userDetailsData[0].billingPin_code || "",
          billingState: userDetailsData[0].billingState || "",
          billing_mobile: userDetailsData[0].contact_details || "",
        });
      }

      if (!shippingData.firstName && checked) {
        setShippingData({
          ...shippingData,
          shipping_user_name: userDetailsData[0].shipping_user_name || "",
          shippingAddress1: userDetailsData[0].billingAddress1 || "",
          shippingAddress2: userDetailsData[0].billingAddress2 || "",
          shippingCity: userDetailsData[0].billingCity || "",
          shippingCountry: userDetailsData[0].billingCountry || "",
          shippingPin_code: userDetailsData[0].billingPin_code || "",
          shippingState: userDetailsData[0].billingState || "",
          shipping_mobile: userDetailsData[0].contact_details || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // Define a function to send data to the API
  const sendDataToAPI = async () => {
    try {
      // Create an object containing both billing and shipping data
      const dataToSend = {
        billingAddress1: billingData.billingAddress1,
        billingAddress2: billingData.billingAddress2,
        billingCity: billingData.billingCity,
        billingCountry: billingData.billingCountry,
        billingPin_code: billingData.billingPin_code,
        billingState: billingData.billingState,
        billing_address: "",
        billing_mobile: billingData.billing_mobile,
        billing_user_name: billingData.billing_user_name,
        contact_details: "",
        country_id: 101,
        email_id: defaultEmail,
        shippingAddress1: shippingData.shippingAddress1,
        shippingAddress2: shippingData.shippingAddress2,
        shippingCity: shippingData.shippingCity,
        shippingCountry: shippingData.shippingCountry,
        shippingPin_code: shippingData.shippingPin_code,
        shippingState: shippingData.shippingState,
        shipping_address: shippingData.shipping_address,
        shipping_mobile: shippingData.shipping_mobile,
        shipping_user_name: shippingData.shipping_user_name,
        user_name: user_name,
        user_type: user_type,
      };

      // console.log('̥JSON.stringify(cartItems)', dataToSend);

      const test = JSON.stringify(dataToSend);

      // Make a POST request to your API endpoint with the JSON data
      const response = await axios.put(
        `/maitri_user_update/${userId}`,
        dataToSend
      );

      // Handle the response as needed
      console.log("API Response:", response.data.data);
    } catch (error) {
      console.error("Error sending data to the API:", error);
    }
  };

  const handleBillingInputChange = (e) => {
    // Update billingData when inputs change
    setBillingData({
      ...billingData,
      [e.target.name]: e.target.value,
    });
  };

  const handleShippingInputChange = (e) => {
    // Update shippingData when inputs change
    setShippingData({
      ...shippingData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(billingData, shippingData);
    sendDataToAPI();
    fetchUserData();
  };

  // console.log('̥billingData', billingData);
  // console.log('shippingData', shippingData);

  return (
    <>
      {userDetails[0] === undefined ? (
        <p>Loading user details...</p>
      ) : (
        <form onSubmit={handleSubmit} className={"mx-0"}>
          <div className="row mb-3">
            <div className="col-md-6 mb-3">
              <label htmlFor="firstName" className="form-label">
                Your Name
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="billing_user_name"
                value={billingData.billing_user_name}
                onChange={handleBillingInputChange}
                required
                ref={ref}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="billingAddress1" className="form-label">
                Address 1
              </label>
              <input
                type="text"
                className="form-control"
                id="billingAddress1"
                name="billingAddress1"
                value={billingData.billingAddress1}
                onChange={handleBillingInputChange}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="billingAddress2" className="form-label">
                Address 2
              </label>
              <input
                type="text"
                className="form-control"
                id="billingAddress2"
                name="billingAddress2"
                value={billingData.billingAddress2}
                onChange={handleBillingInputChange}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="billingCity" className="form-label">
                City
              </label>
              <input
                type="text"
                className="form-control"
                id="billingCity"
                name="billingCity"
                value={billingData.billingCity}
                onChange={handleBillingInputChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="billingPin_code" className="form-label">
                Zip Code
              </label>
              <input
                type="text"
                className="form-control"
                id="billingPin_code"
                name="billingPin_code"
                value={billingData.billingPin_code}
                onChange={handleBillingInputChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="billingState" className="form-label">
                State
              </label>
              <input
                type="text"
                className="form-control"
                id="billingState"
                name="billingState"
                value={billingData.billingState}
                onChange={handleBillingInputChange}
                required
              />
            </div>
            <div className="col-md-6 mt-3">
              <label htmlFor="billingCountry" className="form-label">
                Country
              </label>
              <input
                type="text"
                className="form-control"
                id="billingCountry"
                name="billingCountry"
                value={billingData.billingCountry}
                onChange={handleBillingInputChange}
                required
              />
            </div>
            <div className="col-md-6 mt-3">
              <label htmlFor="billing_mobile" className="form-label">
                Mobile Number
              </label>
              <input
                type="text"
                className="form-control"
                id="billing_mobile"
                name="billing_mobile"
                value={billingData.billing_mobile}
                onChange={handleBillingInputChange}
                required
              />
            </div>
          </div>

          <h4>Shipping Information</h4>

          <div className="form-check mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              defaultValue=""
              id="flexCheckDefault"
              onChange={(e) => setChecked(e.target.checked)}
              checked={checked}
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              Same as Billing Address
            </label>
          </div>

          <div className={"mx-0 " + (checked ? "d-none" : "d-block")}>
            <div className="row mb-3 mt-4">
              <div className="mb-3 col-md-6">
                <label htmlFor="firstName" className="form-label">
                  Your Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shippingFirstName"
                  name="shipping_user_name"
                  value={shippingData.shipping_user_name}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="shippingAddress1" className="form-label">
                  Address 1
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shippingAddress1"
                  name="shippingAddress1"
                  value={shippingData.shippingAddress1}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="shippingAddress2" className="form-label">
                  Address 2
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shippingAddress2"
                  name="shippingAddress2"
                  value={shippingData.shippingAddress2}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="shippingCity" className="form-label">
                  City
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shippingCity"
                  name="shippingCity"
                  value={shippingData.shippingCity}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="shippingPin_code" className="form-label">
                  Zip Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shippingPin_code"
                  name="shippingPin_code"
                  value={shippingData.shippingPin_code}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="shippingState" className="form-label">
                  State
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shippingState"
                  name="shippingState"
                  value={shippingData.shippingState}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="shippingCountry" className="form-label">
                  Country
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shippingCountry"
                  name="shippingCountry"
                  value={shippingData.shippingCountry}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="shipping_mobile" className="form-label">
                  Mobile Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="shipping_mobile"
                  name="shipping_mobile"
                  value={shippingData.shipping_mobile}
                  onChange={handleShippingInputChange}
                  required={checked ? false : true}
                />
              </div>
            </div>
          </div>

          <button type="submit" className="btn btn__primary mt-4">
            Continue to Payment
          </button>
        </form>
      )}
    </>
  );
};

export default BillingStep;
